import { Button, Grid, TextField } from '@material-ui/core';
import { AssociadoSearchResponse } from 'api/Assessor/associado';
import { SearchIcon, SyncIcon } from 'components/Icons';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import { ChangeEvent, FormEvent, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assessorActionPesquisarAssociado } from 'store/modules/assessor/actions';
import { IReducer } from 'store/Reducer';
import useStyle from './style';

interface Props {
  onSearchResult: (resultado: AssociadoSearchResponse) => void;
}

export default function Search({ onSearchResult }: Props) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { procurandoAssociado, atualizandoAssociado } = useSelector(
    (state: IReducer) => state.assessor
  );
  const [term, setTerm] = useState<string>();

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(
      /[^\w\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]/g,
      ''
    );
    setTerm(e.currentTarget.value);
  }, []);

  const handleSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (term) {
        dispatch(
          assessorActionPesquisarAssociado(
            term,
            (fail) => {
              ErrorHandler(fail);
              onSearchResult([]);
            },
            onSearchResult
          )
        );
      }
    },
    [dispatch, term, onSearchResult]
  );

  return (
    <Grid component='form' container spacing={3} onSubmit={handleSubmit}>
      <Grid item xs={6}>
        <TextField
          label={translation.VinculoAssociado.searchFieldLabel}
          onChange={handleChange}
          disabled={procurandoAssociado || atualizandoAssociado}
          fullWidth
        />
      </Grid>
      <Grid item xs={2} className={classes.buttonItem}>
        <Button
          variant='contained'
          color='primary'
          type='submit'
          startIcon={
            procurandoAssociado ? <SyncIcon animated /> : <SearchIcon />
          }
          disabled={
            procurandoAssociado ||
            !term ||
            term.length < 5 ||
            atualizandoAssociado
          }
        >
          {translation.VinculoAssociado.searchButtonLabel}
        </Button>
      </Grid>
    </Grid>
  );
}
